import React from "react";
import { Container, Button } from "react-bootstrap";
import { Whatsapp } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import heroImage from "../assets/hero_bg.svg";
import "../pages/homePage/homePage.css";
import { getHomeData } from "../data/home.js";

const HeroSection = () => {
  const homeData = getHomeData();
  const { heading, description, buttonText, whatsappLink } = homeData.hero;
  const headingLines = typeof heading === "string" ? heading.split("\n") : [];

  return (
    <section
      className="hero-section d-flex align-items-center text-white"
      style={{
        backgroundImage: `url(${heroImage})`,
      }}
    >
      <Container fluid className="px-lg-5 px-3">
        <div className="hero-section-content">
          <h1 className="hero-content-heading">
            {headingLines.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index !== headingLines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </h1>

          <p className="mt-3 mt-md-4 fs-5 text-light ">{description}</p>

          <Button
            as={Link}
            to="/contact"
            variant="none"
            className="hero-btn mt-4"
          >
            {buttonText}
          </Button>
        </div>
      </Container>

      <Link
        to={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="hero-whatsapp-float d-flex align-items-center justify-content-center"
      >
        <Whatsapp className="hero-whatsapp-icon" />
      </Link>
    </section>
  );
};

export default HeroSection;

